import React, { useState, useEffect } from "react";

export default function FloatingActionButton({ hideWhenTemplateSelecting = false }) {
  const [isVisible, setIsVisible] = useState(true); // Start visible on page load
  const [isClient, setIsClient] = useState(false);

  // Initialize client-side rendering
  useEffect(() => {
    setIsClient(true);
  }, []);

  // Use IntersectionObserver to detect when create-biodata section is in view
  useEffect(() => {
    if (!isClient || typeof window === 'undefined') return;

    const target = document.getElementById('create-biodata');
    
    if (!target) {
      // If form section not found, always show FAB
      setIsVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Hide FAB when create-biodata section is in view, show when not in view
        setIsVisible(!entry.isIntersecting);
      },
      { 
        threshold: 0.1, // Trigger when 10% of the section is visible
        rootMargin: '0px 0px -10% 0px' // Add some margin to make it more responsive
      }
    );

    observer.observe(target);
    
    return () => {
      observer.disconnect();
    };
  }, [isClient]);

  const scrollToCreateBiodata = () => {
    if (!isClient || typeof window === 'undefined') return;
    
    const createBiodataSection = document.getElementById('create-biodata');
    if (createBiodataSection) {
      createBiodataSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  // Don't render during SSR
  if (!isClient) {
    return null;
  }

  // Don't render if template selecting
  if (hideWhenTemplateSelecting) {
    return null;
  }
  return (
    <button
      onClick={scrollToCreateBiodata}
      className={`fixed bottom-4 right-4 md:bottom-8 md:right-8 z-[9999] px-4 py-2 md:px-6 md:py-3 bg-gradient-to-r from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600 text-white rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300 flex items-center justify-center group border-2 border-white ${
        isVisible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
      aria-label="Create Your Biodata"
      title="Create Your Biodata"
      style={{ 
        position: 'fixed',
        bottom: '16px',
        right: '16px',
        zIndex: 9999
      }}
    >
      {/* Text Content */}
      <span className="text-xs md:text-sm font-semibold abc-semibold whitespace-nowrap">
        Create Biodata
      </span>
      
      {/* Pulse Animation Ring */}
      <div className="absolute inset-0 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 animate-ping opacity-20"></div>
      
      {/* Tooltip */}
      <div className="absolute right-full mr-4 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none">
        Create Your Biodata
        <div className="absolute left-full top-1/2 transform -translate-y-1/2 w-0 h-0 border-l-4 border-l-gray-900 border-t-4 border-t-transparent border-b-4 border-b-transparent"></div>
      </div>
    </button>
  );
}
